export default __webpack_public_path__ + "static/media/Tanzania.b2c0a2a0.png";